<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >区域报警设置列表
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': isSearch }"
            title="添加"
            icon="e6-icon-add_line"
            @click="$router.push('/areaAlarmSetEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': isSearch }"
            title="查询"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" v-show="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.isOverAll">
            <dict-select
              v-model="slotForms.forms.isOverAll"
              :pkey="'IS_OVER_ALL'"
              placeholder="适用范围"
              clearable
            ></dict-select>
          </el-form-item>
          <el-form-item prop="forms.areaIdList" style="width:260px">
            <!--  <treeselect placeholder="请选择区域"  clearable  v-model="slotForms.forms.areaIdList" :flat="true"
                                     :multiple="true" :options="areaOptions"/>-->
            <e6Select
              :dataList="areaOptions"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="ae6select"
              :placeholder="'请选择区域'"
            >
            </e6Select>
          </el-form-item>
          <el-form-item prop="forms.vehicleIdList" style="width:260px">
            <!-- <treeselect placeholder="请选择车辆" size="mini" v-model="slotForms.forms.vehicleIdList" :flat="true"
                                    :multiple="true" :options="options" />-->
            <e6Select
              :dataList="options"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="ve6select"
              :placeholder="'请选择车辆'"
            >
            </e6Select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab -->
    <section class="g-table-tab-section table-tab-section fixed-view">
      <e6-flank-fix>
        <template slot="fixRight">
          <i
            class="flank-fix__item e6-icon-clear_line"
            @click="handleBatchDeleteAreaAlarm"
          ></i>
        </template>
      </e6-flank-fix>
    </section>
    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
          :selectable="checkBoxCanSelect"
        ></el-table-column>
        <el-table-column label="序号" width="55" fixed type="index" />
        <el-table-column label="区域" min-width="100" prop="areaName" />
        <el-table-column
          label="适用范围"
          min-width="100"
          prop="isOverAllText"
        />
        <el-table-column label="车牌号" min-width="120" prop="vehicleNo" />
        <el-table-column label="是否启用" min-width="100" prop="isApplyText" />
        <el-table-column
          label="进区域报警"
          min-width="100"
          prop="isInAreaText"
        />
        <el-table-column
          label="出区域报警"
          min-width="100"
          prop="isOutAreaText"
        />
        <!-- <el-table-column
          label="区域内停车报警"
          width="120"
          prop="inAreaStopTimeText"
        />
        <el-table-column
          label="区域内超速报警"
          width="120"
          prop="inAreaOverSpeedText"
        />
        <el-table-column
          label="区域外停车报警"
          width="120"
          prop="outAreaStopTimeText"
        />
        <el-table-column
          label="区域内开门报警"
          width="120"
          prop="inAreaOpenDoorText"
        />
        <el-table-column
          label="区域外开门报警"
          width="120"
          prop="outAreaOpenDoorText"
        />
        <el-table-column
          label="区域预警"
          width="120"
          prop="isAreaEarlyAlarmText"
        /> -->
        <!--           <el-table-column label="报警详情" width="200" prop="detail"/>-->
        <el-table-column label="修改人" min-width="130" prop="modifyName" />
        <el-table-column label="修改时间" min-width="150" prop="modifiedTime" />
        <el-table-column
          align="center"
          label="操作"
          min-width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <router-link
              :to="{
                path: '/areaAlarmSetEdit',
                query: { pageType: '2', alarmSetId: scope.row.alarmSetId }
              }"
              >编辑
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 批量删除确认 -->
    <e6-message-box
      :messageBoxVisible.sync="messageBoxVisible"
      @messageBoxSubmit="handleMessageBoxSubmit"
    >
      <div class="batch-delete">确认删除报警设置？</div>
    </e6-message-box>
    <!-- 批量删除确认 end -->
  </div>
</template>

<script>
import {
  FetchDeleteAreaAlarmSetBatch,
  FetchFindByPage,
  FetchFindAreaTree
} from "@/api/alarmSet/areaAlarmSet";
import { FetchVehicleTree } from "@/api/base/vehicle";
import { mapGetters } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
// import dictSelect from "@/components/selectComponents";
import e6Select from "e6select";

export default {
  mixins: [resizeListener],
  components: { e6Select },
  data() {
    return {
      firstLoad: true,
      options: [],
      areaOptions: [],
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: true,
      formExtend: {
        forms: {
          isOverAll: "",
          areaIdList: "",
          vehicleIdList: ""
        },
        extends: []
      },
      tableData: [],
      multipleSelection: [],
      messageBoxVisible: false
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId"]),
    areaAlarmSetIds() {
      let ids = this.multipleSelection.map(item => {
        return item.alarmSetId;
      });
      return ids.length < 1 ? "" : ids.join(",");
    }
  },
  created() {
    this.initVehicleTree();
    this.initAreaTree();
    this.FetchFindByPage(this.mergeObj());
  },
  methods: {
    //初始化车辆树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.options = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    initAreaTree() {
      FetchFindAreaTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.areaOptions = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 获取表格数据
    FetchFindByPage(data) {
      FetchFindByPage(data)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 删除
    FetchDeleteAreaAlarmSetBatch(data) {
      FetchDeleteAreaAlarmSetBatch(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.FetchFindByPage(this.mergeObj());
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      //首次加载时不获取车辆List
      if (this.firstLoad) {
        this.firstLoad = false;
      } else {
        this.vehicleIdList = this.getVehicleIdListParam();
        this.areaIdList = this.getAreaIdListParam();
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        moduleId: this.moduleId,
        vehicleIdList: this.vehicleIdList,
        areaIdList: this.areaIdList,
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    handleResetForm() {
      this.$refs.ae6select.multipleRemoveAll();
      this.$refs.ve6select.multipleRemoveAll();
    },
    // 表格选择改变事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 打开确认删除面板
    handleBatchDeleteAreaAlarm() {
      if (this.areaAlarmSetIds === "") {
        return this.$message({
          showClose: true,
          message: "至少选择一条数据",
          type: "warning",
          duration: 1200
        });
      }
      this.messageBoxVisible = true;
    },
    // 确认删除报警设置
    handleMessageBoxSubmit() {
      this.FetchDeleteAreaAlarmSetBatch({ ids: this.areaAlarmSetIds });
    },
    //设置行是否可选
    checkBoxCanSelect(row, index) {
      //全局设置不可选中删除
      if (row.isOverAll == 1) {
        return false;
      } else {
        return true;
      }
    },
    //获取选中车辆id
    getVehicleIdListParam() {
      let selected = this.$refs.ve6select.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    //获取选中车辆id
    getAreaIdListParam() {
      let selected = this.$refs.ae6select.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
